
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dmca",
      function () {
        return require("private-next-pages/dmca/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dmca"])
      });
    }
  